export class ResourceAttributeDefinitionDto {
	id: number;
	attributeTemplateId: number;
	name: string;
	attributeTypeId: number;
	isRequired: boolean;
	isPrivate: boolean;
	isPricingCatalog: boolean;
	listOrder: number;
	isInUse: boolean;
	attributeLookupListId?: number | null;
}

export class ResourceAttributeValueDto {
    public attributeDefinitionId: number;    
    public value: object;    
}